import { DropdownItem } from '@shared/components/cinico-dropdown/dropdown.component';
import { PagingParams } from 'app/models/searchForAPI/paging-params.model';

export const API_URLS = {
  base: '',
  policyQuoteQuestions: 'policyquotequestions',
  motorQuote: 'motorquotequestiongroup',
  homeQuote: 'homequotequestiongroup',
  healthquotequestions: 'healthquotequestions',
  user: 'user',
  userNationals: 'user/nationals',
  registerUser: 'user/register',
  profile: 'profile',
  ebPolicies: 'epicbridge/nationalid/getpolicies',
  ebClaims: 'epicbridge/policy/getclaims',
  payment: 'plugnpay',
  epicbridge: 'epicbridge',
  clientDrafts: 'clientdrafts',
  clientDraftsCount: 'clientdrafts/clientdraftscount',
  HTHClaims: 'hitechhealth/getclaims',
  getPolicy: 'getpolicy',
  getMotorPolicy: 'getmotorpolicy',
  getHomePolicy: 'gethomepolicy',
  getHealthPolicy: 'hitechhealth/policydetail',
  exportHomeClaim: 'pdftemplates/exporthomeclaim',
  exportMotorClaim: 'pdftemplates/exportmotorclaim',
  exportMotorQuote: 'pdftemplates/exportmotorquote',
  exportHomeQuote: 'pdftemplates/exporthomequote',
  exportHealthQuote: 'pdftemplates/exporthealthquote',
  exportPDF: 'pdftemplates/exportpdf',
  ebRiskLoactions: 'epicbridge/getrisklocation',
  ebQuoteToPolicyJson: 'epicbridge/quotetopolicyjson',
  ebQuoteToPolicy: 'epicbridge/quotetopolicy',
  ebMotorPolicyCreate: 'epicbridge/policy/create/motor',
  ebHomePolicyCreate: 'epicbridge/policy/create/home',
  ebSubmitHomeClaim: 'epicbridge/claim/createhome',
  ebSubmitMotorClaim: 'epicbridge/claim/createmotor',
  ebSubmitMotorQuote: 'epicbridge/quote/submitquotation/motor',
  ebSubmitHomeQuote: 'epicbridge/quote/submitquotation/home',
  ebPolicyFiles: 'epicbridge/policyfiles',
  ebFileLinkData: 'epicbridge/filelinkdata',
  uploadDrivingLicence: 'drivinglicences/uploaddrivinglicence',
  motorPolicyRisks: 'risk/motor',
  homePolicyRisks: 'risk/home',
  images: 'images',
  ebLocationSearch: 'epicbridge/locationsearch',
  ebGetPolicyTransactionterms: 'epicbridge/getpolicytransactionterms',
  ebGetPolicyCreditTerms: 'epicbridge/getpolicycreditterms',
  ebHighPerformanceVehicle: 'ebhighperformancevehicle',
};

export const routes = {
  dashboard: 'dashboard',
  login: 'profile/login',
  policy: 'policy',
  payments: 'payments',
  claims: 'claims',
  quotes: 'quotes',
  createQuote: 'create-quote'
};

export const enumList = {
  Islands: 'islandList',
  // District: 'district',
  AddressTypes: 'addresstypelist',
  PhonenumberTypes: 'phonenumbertypelist',
  EmailTypes: 'emailtypelist',
  ClaimstatusTypes: 'claimstatustypelist',
  ClaimTypes: 'claimtypelist',
  CoverageTypes: 'coveragetypelist',
  DependantTypes: 'dependanttypelist',
  EmploymentstatusTypes: 'employmentstatustypelist',
  FamilymemberTypes: 'familymembertypelist',
  GenderTypes: 'gendertypelist',
  HealthquoteTypes: 'healthquotetypelist',
  HomecoverageTypes: 'homecoveragetypelist',
  MedicalinformationTypes: 'medicalinformationtypelist',
  MotorcoverageTypes: 'motorcoveragetypelist'
};

export class ValidationPatterns {
  static readonly emailPattern: string = '^[a-zA-Z0-9._%+-]+@([a-z-]+)\\.[a-z.]{2,6}$';
  static readonly names: string = "^[a-zA-Z ']*$";
  static readonly specialCharacters: RegExp = /['!@#$%^&*()_\-=+\\[\]{};:",./<>?`~]+/;
  static readonly numbers: string = '^[0-9]+$';
  static readonly alphaNumeric: string = '^[a-zA-Z0-9 ]*$';
  static readonly text: string = '^[a-zA-Z0-9,. \r\n]*$';
  static readonly zipCode: string = '^([a-zA-Z0-9]*){8}';
  static readonly address: string = "^$|^(?!,)(?!.*,,)[._a-zA-Z0-9 ,'\\-]*(?<!,)$";  //'^[_a-zA-Z0-9 ,]*$';
  static readonly numbersGreaterThanZero: string = '^[1-9][0-9]*$';
}

export const phoneMask = '000 0000';
export const phoneMaskPrefix = '+1-345 ';
export const postalCodeMaskPrefix = 'KY';

export enum InputErrorTypes {
  INVALID_CONTROL = 'invalidControl',
  REQUIRED_CONTROL = 'required',
  PASSWORD_STRENGTH = 'passwordStrength'
}

export const initialPagination: PagingParams = { pageNumber: 1, pageSize: 10 };

export const paymentButtonsId = {
  perYearButton: 'per-year-btn',
  perThreeMonthsButton: 'per-3-months-btn',
  perSixMonthsButton: 'per-6-months-btn',
  perTenMonthsButton: 'per-10-months-btn',
  fullButton: 'full'
};

export const licenseGroupList: DropdownItem[] = [
  { key: 0, value: '0' },
  { key: 1, value: '1' },
  { key: 2, value: '1A' },
  { key: 3, value: '2' },
  { key: 4, value: '3' },
  { key: 5, value: '4' },
  { key: 99, value: 'Other' }
];

export const titleList: DropdownItem[] = [
  { key: 0, value: 'Mr.' },
  { key: 1, value: 'Mrs.' },
  { key: 2, value: 'Ms.' },
  { key: 3, value: 'Company' }
];

export const documentNames = {
  schedule: 'Schedule',
  certificate: 'Certificate',
  endorsment: 'Endorsement',
  policy: 'Policy'
};
